// extracted by mini-css-extract-plugin
export var active = "_gt-7";
export var blink = "_gt-8";
export var dropDownSelector = "_gt-4";
export var dropDownWrapper = "_gt-3";
export var fakeCursor = "_gt-6";
export var fontSizeButton = "_gt-9";
export var formQuillEditor = "_gt-0";
export var pressed = "_gt-a";
export var qlBlank = "_gt-1";
export var textFormattingToolbar = "_gt-2";
export var textToolbarOption = "_gt-5";